let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("i2KvU"), load("5bVye"), load("g3FCv"), load("iB2zz"), load("ea9YU"), load("c6MKV"), load("cGAab")]).then(() => parcelRequire('c2Ip8'));